import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = ["type", "disabled", "required", "id", "maxlength", "title", "value"]
const _hoisted_4 = ["type", "disabled", "required", "id", "title", "maxlength", "value"]
const _hoisted_5 = ["disabled", "required", "rows", "title", "id", "maxlength", "value"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Found illegal tag ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Found illegal mode ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!
  const _component_FormGridMember = _resolveComponent("FormGridMember")!

  return (this.isFlexMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (this.label != null)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: _normalizeClass(_ctx.computedLabelCss),
              for: this.id != null ? this.id : _ctx.$id('textInput')
            }, _toDisplayString(this.label), 11, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          class: _normalizeClass(_ctx.computedInputCss),
          type: this.type,
          disabled: this.disabled,
          ref: "flexInput",
          required: this.required,
          id: this.id != null ? this.id : _ctx.$id('textInput'),
          maxlength: this.maxlength ?? '',
          title: this.title,
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = ($event: any) => {this.$emit('update:modelValue', $event.target.value); this.stringValue = $event.target.value}),
          onBlur: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.textBoxBlur1 && _ctx.textBoxBlur1(...args)), ["stop"]))
        }, null, 42, _hoisted_3)
      ]))
    : (this.isFormGridMode)
      ? (_openBlock(), _createBlock(_component_FormGridMember, { key: 1 }, {
          label: _withCtx(({ controlId : controlId, class : clazz }) => [
            (this.label != null)
              ? (_openBlock(), _createBlock(_component_Label, {
                  key: 0,
                  class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                  for: controlId
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(this.label), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "for"]))
              : _createCommentVNode("", true)
          ]),
          control: _withCtx(({ id : id }) => [
            (this.isInput)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  class: _normalizeClass(_ctx.computedInputCss),
                  type: this.type,
                  disabled: this.disabled,
                  required: this.required,
                  id: id,
                  title: this.title,
                  maxlength: this.maxlength ?? '',
                  value: _ctx.modelValue,
                  onInput: _cache[2] || (_cache[2] = ($event: any) => {this.$emit('update:modelValue', $event.target.value); this.stringValue = $event.target.value}),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.textBoxBlur1 && _ctx.textBoxBlur1(...args)))
                }, null, 42, _hoisted_4))
              : (this.isTextArea)
                ? (_openBlock(), _createElementBlock("textarea", {
                    key: 1,
                    class: _normalizeClass(_ctx.computedTextAreaCss),
                    disabled: this.disabled,
                    required: this.required,
                    rows: this.rows,
                    title: this.title,
                    id: id,
                    maxlength: this.maxlength ?? '',
                    value: _ctx.modelValue,
                    onInput: _cache[4] || (_cache[4] = ($event: any) => {this.$emit('update:modelValue', $event.target.value); this.stringValue = $event.target.value}),
                    onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.textBoxBlur1 && _ctx.textBoxBlur1(...args)))
                  }, null, 42, _hoisted_5))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_6
                  ], 64))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_7
        ], 64))
}